import { createFileRoute } from "@tanstack/react-router";
import { BekreftSelskapsPage } from "@/features/avtaler/components/bekreftelse/BekreftSelskapsPage";

export const Route = createFileRoute(
  "/_app/avtaler/$avtalerId/selskap/bekreftelse/",
)({
  component: BekreftSelskapsPage,
  head: () => ({
    meta: [
      {
        title: "Bekreftelse | Norgespris for Fjernvarme",
      },
    ],
  }),
});
